import { render, staticRenderFns } from "./RouterTransition.vue?vue&type=template&id=70c9e45a&scoped=true&"
import script from "./RouterTransition.vue?vue&type=script&lang=js&"
export * from "./RouterTransition.vue?vue&type=script&lang=js&"
import style0 from "./RouterTransition.vue?vue&type=style&index=0&id=70c9e45a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c9e45a",
  null
  
)

export default component.exports